import { IEventRound } from '../../../../../../store/admin/eventRounds/store';

export const getActiveTab = (currentPage: string, rounds: IEventRound[], currentRound: number) => {
  return currentPage === 'round'
    ? 1 +
        (rounds
          ? rounds.sort((r1, r2) => r1.order - r2.order).findIndex(r => r.id === currentRound)
          : 0)
    : currentPage === 'complete'
    ? 1 + rounds.length
    : 0;
};
